module.exports = __webpack_public_path__ + "img/hero-mb.a55923e7.svg";